import React from 'react';
import Form from 'react-bootstrap/Form';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import FloatingLabel from 'react-bootstrap/FloatingLabel';
import Tooltip from 'react-bootstrap/Tooltip';
import { Link } from 'react-router-dom';
import './DetailsViewer.css';

const DetailsViewer = ({ data: fields, headerContent, footerContent }) => {
	return (
		<div className='details-container-wrapper'>
			{headerContent}
			<Form className='details-container' onSubmit={(e) => e.preventDefault()}>
				{fields
					.filter((f) => !f.hide)
					.map((field, index) =>
						field.type === 'checkbox' ? (
							<div key={index} className={`form-wrapper checkbox-wrapper ${field.cols === 12 ? 'grid-col-span-2' : ''}`}>
								<FloatingLabel
									controlId={`floating-checkbox-${index}-${field.label}`}
									label={field.markedLabel ? <><span className='label-mark'>* </span>{field.label}</> : field.label}
								>
									<div className="form-control checkbox-control">
										<Form.Check
											type='checkbox'
											id={`checkbox-${index}-${field.label}`}
											checked={field.value}
											readOnly
											disabled
										/>
									</div>
								</FloatingLabel>
							</div>
						) : !field.tooltip ? (
							<div key={index} className={`form-wrapper ${field.cols === 12 ? 'grid-col-span-2' : ''}`}>
								<FloatingLabel
									controlId={`floating-${field.label}`}
									label={field.markedLabel ? <><span className='label-mark'>* </span>{field.label}</> : field.label}
								>
									{field.link && field.value ? (
										<div className="form-control form-control-link-wrapper">
											<Link 
												to={field.link}
												className="form-control-link"
											>
												{field.value}
											</Link>
										</div>
									) : (
										<Form.Control type={field.type} value={field.value} readOnly />
									)}
								</FloatingLabel>
								{
									field.button && !field.button.hide && <button className='header-button' onClick={field.button.onClick}> {field.button.label}</button>
								}
							</div>
						) : (
							<OverlayTrigger
								key={index}
								placement='top'
								overlay={<Tooltip id={`tooltip-${index}`}>{field.tooltip}</Tooltip>}
							>
								<FloatingLabel
									className={field.cols === 12 ? 'grid-col-span-2' : ''}
									controlId={`floating-${field.label}`}
									label={field.markedLabel ? <><span className='label-mark'>* </span>{field.label}</> : field.label}
								>
									<Form.Control type={field.type} value={field.value} readOnly rows={field.rows || 3} />
								</FloatingLabel>
							</OverlayTrigger>
						),
					)}
			</Form>
			{footerContent}
		</div>
	);
};

export default DetailsViewer;
